import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setFx } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

const CurrencyContext = createContext(null);
const DEMO_KEY = "finlo_demo_currency";

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [fx, setFxState] = useState(null);
  const [code, setCode] = useState(null);

  useEffect(() => {
    if (!user) { setCode(null); setFx("GBP", 1); return; }
    let alive = true;
    (async () => {
      let rates = fx;
      if (!rates) {
        try { rates = (await api.get("/fx/rates")).data; } catch { rates = { rates: { GBP: 1 }, date: null }; }
        if (alive) setFxState(rates);
      }
      let c = user.is_demo ? localStorage.getItem(DEMO_KEY) : user.currency;
      if (!c) {
        try {
          c = (await api.post("/fx/detect", { locale: navigator.language })).data.currency;
          if (user.is_demo) localStorage.setItem(DEMO_KEY, c);
        } catch { c = "GBP"; }
      }
      if (!rates.rates[c]) c = "GBP";
      if (!alive) return;
      setFx(c, rates.rates[c]);
      setCode(c);
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const changeCurrency = async (c) => {
    if (user.is_demo) localStorage.setItem(DEMO_KEY, c);
    else await api.patch("/auth/currency", { currency: c });
    setFx(c, fx.rates[c]);
    setCode(c);
  };

  return (
    <CurrencyContext.Provider value={{ code, ratesDate: fx?.date, rates: fx?.rates, available: fx ? Object.keys(fx.rates) : ["GBP"], changeCurrency, ready: !user || !!code }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
